<template>
	<page style="background: #fff">
		<c-form ref="form">
			<c-form-item label="紧急程度" required>
				<c-radio-group name="emergency_level" :options="orderUrgencyDic"></c-radio-group>
			</c-form-item>
			<c-form-item label="加班类型" required>
				<c-select v-model="overtimeType" name="overtime_type" :options="overtimeTypeDic" :disabled="!!source" @change="typeHandle"></c-select>
			</c-form-item>
			<c-form-item v-show="overtimeType == 1" label="关联售后工单" required>
				<c-select v-model="workOrderId" ref="orderSelect" name="order_id" async :disabled="!!source" :clear="false" @search="searchOrder">
					<template #option="{data, selected}">
						<select-option
							:name="data.name"
							:info="[
								`${data.data.customer_name||'-'} | ${data.data.create_date}`
							]"
							:selected="selected"
						></select-option>
					</template>
				</c-select>
				<info-card code="AFTERSALE_ORDER" :id="workOrderId"></info-card>
			</c-form-item>
			<c-form-item label="加班明细" name="item_list" required>
				<detail-card v-for="(item, i) in itemList" :key="i" :index="i + 1">
					<template #form>
						<detail-card-form v-if="overtimeType == 1" label="加班人员" required>
							<c-select v-model="item.user_id" name="user_id" :options="memberList"></c-select>
						</detail-card-form>
						<detail-card-form label="开始时间" required>
							<c-datetime v-model="item.start_date" name="start_date" type="datetime" time-accuracy="min" format="yyyy-MM-dd hh:mm" @change="changeDate(item, 'start_date')"></c-datetime>
						</detail-card-form>
						<detail-card-form label="结束时间" required>
							<c-datetime v-model="item.end_date" name="end_date" type="datetime" time-accuracy="min" format="yyyy-MM-dd hh:mm" @change="changeDate(item, 'end_date')"></c-datetime>
						</detail-card-form>
						<detail-card-form label="加班时长" required>
							<c-input v-model="item.overtime_duration" type="number" name="overtime_duration" decimal="1" :range="[0.1, Infinity]" append-text="小时"></c-input>
						</detail-card-form>
					</template>
					<template #button>
						<c-link color="red" icon="tf-trash" @click="itemList.splice(i, 1)">删除</c-link>
					</template>
				</detail-card>
				<c-button size="form" color="main" hollow prepend-icon="c-icon-add" style="width: 100%; margin-top: .2rem;" @click="addItemHandle">新增加班明细</c-button>
			</c-form-item>
			<c-form-item label="加班事由" :required="overtimeType == 2">
				<c-input type="textarea" name="reason"></c-input>
			</c-form-item>
			<c-form-item label="上传凭证" :required="overtimeType == 2">
				<c-upload-file name="voucher_images" media multiple="9" type="image" :side="false"></c-upload-file>
			</c-form-item>

			<!-- <cut-line></cut-line> -->

			<doc-flow ref="flow" flow="6"></doc-flow>
		</c-form>

		<template #button>
			<c-button size="form" @click="submitHandle(-1)">暂存</c-button>
			<c-button size="form" color="main" @click="submitHandle(1)">确认提交</c-button>
		</template>
	</page>
</template>

<script>
	import {mapState} from 'vuex';

	export default {
		props: {
			id: String,
			source: String
		},

		data() {
			return {
				overtimeType: '',
				workOrderId: '',
				itemList: [],
				memberList: []
			}
		},

		computed: {
			...mapState(['userInfo', 'orderUrgencyDic', 'overtimeTypeDic'])
		},

		watch: {
			workOrderId(val) {
				if (val) {
					this.request({
						url: '/after/sale/order/detail',
						data: {
							id: val
						},
						success: ({detailInfo, memberList}) => {
							this.memberList = memberList.map(item => {
								return {
									name: item.user_realname,
									value: item.user_id
								}
							});
						}
					});
				} else {
					this.memberList = [];
				}
			}
		},

		mounted() {
			if (this.id) {
				this.request({
					url: '/overtime/application/detail',
					data: {
						id: this.id
					},
					success: ({detailInfo}) => {
						this.$refs.form.set(detailInfo);
						this.itemList = detailInfo.detail_list;
						this.$refs.orderSelect.setValueData([{
							name: detailInfo.order_number,
							value: detailInfo.order_id
						}]);
					}
				})
			} else if (this.source) {
				this.request({
					url: '/after/sale/order/detail',
					data: {
						id: this.source
					},
					success: ({detailInfo}) => {
						this.$refs.form.set({
							emergency_level: 1,
							overtime_type: 1
						});
						this.$refs.orderSelect.setValueData([{
							name: detailInfo.order_number,
							value: detailInfo.id
						}]);
						this.addItemHandle();
					}
				});
			} else {
				this.$refs.form.set({
					emergency_level: 1
				});
				this.addItemHandle();
			}
		},

		methods: {
			typeHandle(data) {
				if (data.value == 2) {
					this.workOrderId = '';
				}
				this.itemList = [];
				this.addItemHandle();
			},

			searchOrder(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'AFTERSALE_ORDER',
                        is_member: 1,
						status: [2, 3, 4, 5],
                        keyword: keyword
					},
					success: data => {
						resolve(data.map(item => {
							return {
								name: item.data.order_number,
								value: item.data.id,
								data: item.data
							}
						}));
					}
				})
			},

			changeDate(item, type) {
				if (item.start_date && item.end_date) {
					if (item.start_date >= item.end_date) {
						this.$message({
							message: '开始时间需早于结束时间'
						});
						this.$nextTick(() => {
							item[type] = '';
						});
					} else {
						item.overtime_duration = parseFloat(((new Date(item.end_date).getTime() - new Date(item.start_date).getTime()) / 1000 / 60 / 60).toFixed(1));
					}
				}
			},

			addItemHandle() {
				this.itemList.push({
					user_id: this.overtimeType == 2 ? this.userInfo.id : ''
				});
			},

			submitHandle(state) {
				this.$refs.form.submit({
					url: this.id ? '/overtime/application/update' : '/overtime/application/add',
					rule: {
						emergency_level: '请选择紧急程度',
						overtime_type: '请选择加班类型',
						order_id: [{
							type: 'empty',
							message: '请选择关联工单',
							skip: () => {
								return this.overtimeType == 2;
							}
						}],
						item_list: () => {
							if (!this.itemList.length || this.itemList.find(item => {
								return !item.user_id || !item.start_date || !item.end_date || !item.overtime_duration;
							})) {
								return '请完善加班明细';
							}
							return true;
						},
						voucher_images: [{
							type: 'empty',
							message: '请上传凭证',
							skip: () => {
								return this.overtimeType != 2;
							}
						}],
						reason: [{
							type: 'empty',
							message: '请填写加班事由',
							skip: () => {
								return this.overtimeType != 2;
							}
						}]
					},
					dataFormatter: data => {
						data.id = this.id;
						data.status = state;
						data.detail_list = this.itemList;
						data.voucher_images = data.voucher_images.join(',')
						return data;
					},
					success: (data, res) => {
						this.$refs.flow.apply(state, res.transaction, () => {
							this.$message({
								message: '提交成功',
								mask: true
							});
							setTimeout(() => {
								if (this.id) {
									this.mp.navigateBack();
								} else {
									this.mp.redirectWeb('/affairs/overtime/detail', {id: res.detailInfo.id});
								}
							}, 1000);
						});
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>